import { LanguageCodes } from "../../constants/enums";
import ar from "./ar";
import da from "./da";
import en from "./en";
import fa from "./fa";
import tr from "./tr";
import vi from "./vi";

export default {
  [LanguageCodes.English]: en,
  [LanguageCodes.Persian]: fa,
  [LanguageCodes.Arabic]: ar,
  [LanguageCodes.Vietnamese]: vi,
  [LanguageCodes.Turkish]: tr,
  [LanguageCodes.Darija]: da,
};
